import { render, staticRenderFns } from "./InternDeprecated.vue?vue&type=template&id=46f4daee&scoped=true"
import script from "./InternDeprecated.vue?vue&type=script&lang=js"
export * from "./InternDeprecated.vue?vue&type=script&lang=js"
import style0 from "./InternDeprecated.vue?vue&type=style&index=0&id=46f4daee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f4daee",
  null
  
)

export default component.exports